import { Navigate, Route, Routes } from "react-router-dom";

import { AdminSection } from "screens/Admin/AdminSection/AdminSection";
import { CampaignsList } from "screens/Campaigns/CampaignsList/CampaignsList";
import { DashboardSection } from "screens/Dashboard/DashboardSection/DashboardSection";
import { Feedback } from "screens/Feedback/Feedback";
import { HearAboutUs } from "screens/HearAboutUs/HearAboutUs";
import { Links } from "constants/Links";
import { MessagingList } from "screens/Messaging/MessagingList";
import React from "react";
import { ReportedUsers } from "screens/ReportedUsers/ReportedUsers";
import StartChatPage from "pages/StartChatPage/StartChatPage";
import { UserDetail } from "screens/Users/ModifyUser/UserDetail";
import { UsersListing } from "screens/Users/UsersListing/UsersListing";
import { View } from "react-native-web";
import { useDisplay } from "context/DisplayContext";
import { RetentionDashboardSection } from "screens/Retention/RetentionDashboardSection/RetentionDashboardSection";

export default function MainNavigator() {
  const { showSidebar, isMobile, isTablet } = useDisplay();

  return (
    <View
      style={{
        flex: 1,
        minWidth: 0,
        marginLeft: (isMobile || isTablet) ? 0 : (showSidebar ? 280 : 60),
        paddingTop: 80,
        overflowX: "hidden",
      }}
    >
      <Routes>
        <Route exact path={Links.Dashboard} element={<DashboardSection />} />
        {/** redirects */}
        <Route
          path={"/*"}
          element={<Navigate replace to={Links.Dashboard} />}
        />

        <Route
          exact
          path={Links.Retention}
          element={<RetentionDashboardSection />}
        />
        <Route exact path={Links.Team} element={<AdminSection />} />
        <Route exact path={Links.Users} element={<UsersListing />} />
        <Route exact path={Links.UserDetail} element={<UserDetail />} />

        <Route exact path={Links.ReportedUsers} element={<ReportedUsers />} />
        <Route exact path={Links.Feedback} element={<Feedback />} />
        <Route exact path={Links.HearAboutUs} element={<HearAboutUs />} />
        <Route exact path={Links.Messaging} element={<MessagingList />} />
        <Route exact path={Links.StartChat} element={<StartChatPage />} />

        {/* Campaigns */}
        <Route exact path={Links.Campaigns} element={<CampaignsList />} />

        {/* <Route exact path={Links.UserDetail} element={<UserDetail />} /> */}
      </Routes>
    </View>
  );
}
